(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["agreement-check"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(event) {
  const targetButton = document.querySelector('.checkout__button');
  const agree = document.querySelector('input[name="kiwabi-agree"]');
  targetButton.disabled = true;
  agree.addEventListener('click', () => {
    if(agree.checked){
      targetButton.disabled = false;
    } else {
      targetButton.disabled = true;
    }
  });
}, false);
  } catch(e) { console.error(e); }
})();

})();
